import { useEffect, useState } from "react";
import axios from "../axios/axios";
import Cookies from "js-cookie";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import FormCv from "../components/form-cv";
import ProtectedRoute from "../components/ProtectedRoute";

export default function ModifierCv() {
  const navigate = useNavigate();
  const { id } = useParams();

  const token = Cookies.get("auth_token");
  const user = JSON.parse(Cookies.get("auth_user"));
  //Pour le cas de postuler
  const idOffre = Cookies.get("idoffre");

  const [chargement, setChargement] = useState(false);
  const [allFormations, setAllFormations] = useState([]);
  const [allExperpiances, setAllExperpiances] = useState([]);

  useEffect(() => {
    getCv();
    getDomainesEtEtablissementsEtEntreprises();
  }, []);

  const getDomainesEtEtablissementsEtEntreprises = () => {
    axios
      .get("/getDomainesEtEtablissementsEtEntreprises", {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setAllFormations(response.data.allFormation);
        setAllExperpiances(response.data.allExperpiance);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // states profile
  const [idCV, setIdCV] = useState("");
  const [nom, setNom] = useState("");
  const [image, setImage] = useState(null);
  const [imageVisualise, setImageVisualise] = useState(null);
  const [civilite, setCivilite] = useState("");
  const [telephone, setTelephone] = useState("");
  const [dateNaissance, setDateNaissance] = useState("");
  const [email, setEmail] = useState("");
  const [domaineEtude, setDomaineEtude] = useState("");
  const [niveau, setNiveau] = useState("");
  const [displayphoto, setDisplayphoto] = useState("1");
  const [descriptionCv, setDescriptionCv] = useState(null);
  const [msgErreurTap1, setMsgErreurTap1] = useState("");

  const [piecejointes, setPiecejointes] = useState([]);
  const [listPJ, setListPJ] = useState([0]);

  const ajouterAuterFichier = () => {
    setListPJ([...listPJ, listPJ.length]);
  };

  const removeFichier = (value, index) => {
    var arr = listPJ.filter((item) => item !== value);
    var pj = piecejointes.filter((item, i) => i !== index);
    setListPJ(arr);
    setPiecejointes(pj);
  };

  const handleRadioChange = (event) => {
    setDisplayphoto(event.target.value);
  };

  // states formation

  const [msgErreurTabFormation, setMsgErreurTabFormation] = useState("");
  const [msgDateForm, setMsgDateForm] = useState("");
  const [msgErreurEncourForma, setMsgErreurEncourForma] = useState("");
  const [searchInputEtablissement, setSearchInputEtablissement] = useState("");
  const [filteredResultsEtablissement, setFilteredResultsEtablissement] =
    useState([]);
  const [currentIndex, setCurrentIndex] = useState();

  const [formations, setFormations] = useState([
    {
      moisDebut: "",
      anneeDebut: "",
      moisFin: "",
      anneeFin: "",
      encoureFormation: "",
      titreFormation: "",
      specialite: "",
      etablissmenet: "",
      ville: "",
      descriptionFormation: "",
    },
  ]);

  const handleAjouterFormation = () => {
    // Ajoutez une nouvelle formation à la liste
    setFormations([
      ...formations,
      {
        moisDebut: "",
        anneeDebut: "",
        moisFin: "",
        anneeFin: "",
        encoureFormation: "",
        titreFormation: "",
        specialite: "",
        etablissmenet: "",
        ville: "",
        descriptionFormation: "",
      },
    ]);
  };

  const handleChangeFormation = (index, attributeName, value) => {
    // Mettez à jour la liste des formations en modifiant l'attribut spécifique de la formation à l'index donné
    const updatedFormations = [...formations];

    // Si l'utilisateur choisit moisDebut ou anneeDebut, effacez la valeur de encoureFormation et décochez la case à cocher
    if (
      (attributeName === "moisFin" || attributeName === "anneeFin") &&
      value !== ""
    ) {
      updatedFormations[index]["encoureFormation"] = false;
    }

    updatedFormations[index][attributeName] = value;
    setFormations(updatedFormations);
  };

  const handleSupprimerFormation = (index) => {
    // Créez une nouvelle liste en excluant l'élément à supprimer
    const updatedFormations = formations.filter((_, i) => i !== index);
    setFormations(updatedFormations);
  };

  const onChangeEtablissement = (e, index) => {
    const updatedFormations = [...formations];
    updatedFormations[index].etablissmenet = e.target.value;
    setCurrentIndex(index);
    setFormations(updatedFormations);
    setSearchInputEtablissement(e.target.value);
    if (searchInputEtablissement !== "") {
      const filteredDataEtablissement = allFormations.filter((item) => {
        return Object.values(item)
          .join("")
          .toLowerCase()
          .includes(searchInputEtablissement.toLowerCase());
      });
      setFilteredResultsEtablissement(filteredDataEtablissement);
    } else {
      setFilteredResultsEtablissement([]);
    }
  };

  const selectItemsEtablissement = (e, index) => {
    const updatedFormations = formations;
    updatedFormations[index].etablissmenet = e.target.value;
    setFormations(updatedFormations);
    setFilteredResultsEtablissement([]);
  };

  // states experience
  const [msgErreurTabExperience, setMsgErreurTabExperience] = useState("");
  const [msgErrDateExper, seMsgErrDateExper] = useState("");
  const [msgErreurEncourExper, setMsgErreurEncourExper] = useState("");
  const [searchInputEntreprise, setSearchInputEntreprise] = useState("");
  const [filteredResultsEntreprise, setFilteredResultsEntreprise] = useState(
    []
  );

  const [experiences, setExperiences] = useState([
    {
      moisDebutExper: "",
      anneeDebutexper: "",
      moisFinExper: "",
      anneeFinexper: "",
      encoureEper: "",
      titreProjet: "",
      nomEntreprise: "",
      descriptionExperience: "",
    },
  ]);

  const handleAjouterExperience = () => {
    // Ajoutez une nouvelle formation à la liste
    setExperiences([
      ...experiences,
      {
        moisDebutExper: "",
        anneeDebutexper: "",
        moisFinExper: "",
        anneeFinexper: "",
        encoureEper: "",
        titreProjet: "",
        nomEntreprise: "",
        descriptionExperience: "",
      },
    ]);
  };

  const handleChangeExperience = (index, attributeName, value) => {
    // Mettez à jour la liste des formations en modifiant l'attribut spécifique de la formation à l'index donné
    const updatedExperiences = [...experiences];

    // Si l'utilisateur choisit moisDebut ou anneeDebut, effacez la valeur de encoureFormation et décochez la case à cocher
    if (
      (attributeName === "moisFinExper" || attributeName === "anneeFinexper") &&
      value !== ""
    ) {
      updatedExperiences[index]["encoureEper"] = false;
    }

    updatedExperiences[index][attributeName] = value;
    setExperiences(updatedExperiences);
  };

  const handleSupprimerExperience = (index) => {
    // Créez une nouvelle liste en excluant l'élément à supprimer
    const updatedExperiences = experiences.filter((_, i) => i !== index);
    setExperiences(updatedExperiences);
  };

  const onChangeEntreprise = (e, index) => {
    setCurrentIndex(index);
    const updatedExperiences = [...experiences];
    updatedExperiences[index].nomEntreprise = e.target.value;
    setExperiences(updatedExperiences);
    setSearchInputEntreprise(e.target.value);
    if (searchInputEntreprise !== "") {
      const filteredDataEntreprise = allExperpiances.filter((item) => {
        return Object.values(item)
          .join("")
          .toLowerCase()
          .includes(searchInputEntreprise.toLowerCase());
      });
      setFilteredResultsEntreprise(filteredDataEntreprise);
    } else {
      setFilteredResultsEntreprise([]);
    }
  };

  const selectItemsEntreprise = (e, index) => {
    const updatedExperiences = [...experiences];
    updatedExperiences[index].nomEntreprise = e.target.value;
    setExperiences(updatedExperiences);
    setFilteredResultsEntreprise([]);
  };

  // states langue
  const [langues, setLangues] = useState([{ nomLangue: "", niveauLangue: "" }]);
  const [msgErreurTabLangue, setMsgErreurTabLangue] = useState("");
  const handleAjouterLangue = () => {
    // Ajoutez une nouvelle formation à la liste
    setLangues([...langues, { nomLangue: "", niveauLangue: "" }]);
  };

  const handleChangeLangue = (index, attributeName, value) => {
    // Mettez à jour la liste des formations en modifiant l'attribut spécifique de la formation à l'index donné
    const updatedLangues = [...langues];
    updatedLangues[index][attributeName] = value;
    setLangues(updatedLangues);
  };

  const handleSupprimerLangue = (index) => {
    // Créez une nouvelle liste en excluant l'élément à supprimer
    const updatedLangus = langues.filter((_, i) => i !== index);
    setLangues(updatedLangus);
  };

  // state competance
  const [competences, setCompetences] = useState([
    { skillNom: "", niveauSkill: "" },
  ]);
  const [msgErreurTabCompetance, setMsgErreurTabCompetance] = useState("");
  const handleAjouterCompetence = () => {
    // Ajoutez une nouvelle formation à la liste
    setCompetences([...competences, { skillNom: "", niveauSkill: "" }]);
  };

  const handleChangeCompetence = (index, attributeName, value) => {
    // Mettez à jour la liste des formations en modifiant l'attribut spécifique de la formation à l'index donné
    const updatedCompetences = [...competences];
    updatedCompetences[index][attributeName] = value;
    setCompetences(updatedCompetences);
  };

  const handleSupprimerCompetence = (index) => {
    // Créez une nouvelle liste en excluant l'élément à supprimer
    const updatedCompetences = competences.filter((_, i) => i !== index);
    setCompetences(updatedCompetences);
  };

  const handleCheckboxChangeFormation = (index) => {
    const updatedFormations = [...formations];
    updatedFormations[index].encoureFormation =
      !updatedFormations[index].encoureFormation;
    updatedFormations[index].moisFin = "";
    updatedFormations[index].anneeFin = "";

    setFormations(updatedFormations);
  };

  const handleCheckboxChangeExperience = (index) => {
    const updatedExperiences = [...experiences];
    updatedExperiences[index].encoureEper =
      !updatedExperiences[index].encoureEper;
    updatedExperiences[index].moisFinExper = "";
    updatedExperiences[index].anneeFinexper = "";
    setExperiences(updatedExperiences);
  };

  // Validations des inputs

  // check validate tab  profile
  const checkValidateTabProfile = () => {
    if (
      nom === "" ||
      civilite === "" ||
      telephone === "" ||
      dateNaissance === "" ||
      niveau === ""
    ) {
      return false;
    }
    return true;
  };

  const errorMessagesTabProfile = () => {
    setMsgErreurTap1("Ce champ est Obligatoire ");
  };

  // check validate tab  formation
  const checkValidateTabFormation = () => {
    // Utilisez la méthode every() pour vérifier si toutes les formations passent la condition
    const isValid = formations.every((formation, index) => {
      if (
        formation.moisDebut === "" ||
        formation.anneeDebut === "" ||
        formation.titreFormation === "" ||
        formation.specialite === "" ||
        formation.etablissmenet === "" ||
        formation.ville === "" ||
        formation.niveau === ""
      ) {
        return false;
      }
      if (
        (formation.moisFin === "" || formation.anneeFin === "") &&
        formation.encoureFormation == false
      ) {
        return false;
      }

      if (
        formation.anneeFin != "" &&
        formation.anneeDebut != "" &&
        (formation.anneeFin < formation.anneeDebut ||
          (formation.anneeFin === formation.anneeDebut &&
            formation.moisDebut > formation.moisFin))
      ) {
        return false;
      }

      return true; // Retourne true si toutes les conditions sont satisfaites
    });

    return isValid;
  };

  const errorMessagesTabFormation = () => {
    setMsgErreurEncourForma(
      "Il faut spécifier la date fin de la formation ou si elle est en cours ! "
    );
    setMsgErreurTabFormation("Ce champ est Obligatoire ");
    setMsgDateForm(
      "La date fin  de la formation doit être postérieure à la date debut"
    );
  };

  // check validate tab  experience
  const checkValidateTabExperience = () => {
    // Utilisez la méthode every() pour vérifier si toutes les formations passent la condition
    const isValid = experiences.every((experience) => {
      if (
        (experience.anneeDebutexper != "" || experience.moisDebutExper != "") &&
        (experience.moisFinExper === "" || experience.anneeFinexper === "") &&
        experience.encoureEper == 0
      ) {
        return false;
      }
      if (
        experience.anneeFinexper != "" &&
        experience.anneeDebutexper != "" &&
        (experience.anneeFinexper < experience.anneeDebutexper ||
          (experience.anneeFinexper == experience.anneeDebutexper &&
            experience.moisDebutExper > experience.moisFinExper))
      ) {
        return false;
      }

      if (
        (experience.anneeDebutexper != "" || experience.moisDebutExper != "") &&
        (experience.nomEntreprise === "" || experience.titreProjet === "")
      ) {
        return false;
      }

      return true; // Retourne true si toutes les conditions sont satisfaites
    });

    return isValid;
  };

  const errorMessagesTabExperience = () => {
    setMsgErreurTabExperience("Ce champ est Obligatoire");
    seMsgErrDateExper(
      "La date fin  de l'experience doit être postérieure à la date debut"
    );
    setMsgErreurEncourExper(
      "Il faut spécifier la date fin de l'experience ou si elle est en cours !"
    );
  };

  // check validate tab  langue
  const checkValidateTabLangue = () => {
    const isValid = langues.every((langue) => {
      if (langue.nomLangue === "" || langue.niveauLangue === "") {
        return false;
      }

      return true; // Retourne true si toutes les conditions sont satisfaites
    });

    return isValid;
  };

  const errorMessagesTapLangue = () => {
    setMsgErreurTabLangue("Ce champ est Obligatoire");
  };

  // check validate tab  competance
  const checkValidateTabCompetance = () => {
    const isValid = competences.every((competence) => {
      if (
        (competence.skillNom != "" && competence.niveauSkill === "") ||
        (competence.skillNom === "" && competence.niveauSkill != "")
      ) {
        return false;
      }
      return true;
    });
  };

  const errorMessagesTabLangueCompetance = () => {
    setMsgErreurTabCompetance("Ce champ est Obligatoire");
  };

  const getCv = () => {
    setChargement(true);
    var moisFin = 0;
    var anneeFin = 0;
    var encoureFormation = null;

    var moisFinExper = 0;
    var anneeFinexper = 0;
    var encoureEper = null;

    axios
      .get(`/editeCv/${id}`, {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        if (
          response.data.cv == null ||
          response.data.msg == "msgNoAuthNoAdmin"
        ) {
          navigate(`${process.env.PUBLIC_URL}/profile`);
        } else {
          setIdCV(id);
          setEmail(response.data.cv.email);
          setNom(response.data.cv.nom);
          setTelephone(response.data.cv.telephone);
          setImage(response.data.cv.photo);
          setCivilite(response.data.cv.civilite);
          setDateNaissance(response.data.cv.date_naissance);
          setDomaineEtude(response.data.cv.domain_d_etude);
          setNiveau(response.data.cv.niveau);
          setDisplayphoto(response.data.cv.displayphoto);
          setDescriptionCv(response.data.cv.description);

          const updatedFormations = response.data.formations.map(
            (formation) => {
              const moisDebut = formation.date_debut.substring(5, 7);
              const anneeDebut = formation.date_debut.substring(0, 4);
              const titreFormation = formation.titre_formation;
              const etablissmenet = formation.etablissement;
              const specialite = formation.specialite;
              const ville = formation.ville;
              const descriptionFormation = formation.description;
              if (formation.date_fin != null && formation.encoure == 0) {
                moisFin = formation.date_fin.substring(5, 7);
                anneeFin = formation.date_fin.substring(0, 4);
              } else {
                encoureFormation = formation.encoure;
                moisFin = "";
                anneeFin = "";
              }

              return {
                ...formation,
                titreFormation,
                specialite,
                etablissmenet,
                ville,
                moisDebut,
                anneeDebut,
                moisFin,
                anneeFin,
                encoureFormation,
                descriptionFormation,
              };
            }
          );

          setFormations(updatedFormations);

          const updatedExperiences = response.data.experiences.map(
            (experience) => {
              const moisDebutExper = experience.date_debut.substring(5, 7);
              const anneeDebutexper = experience.date_debut.substring(0, 4);
              const nomEntreprise = experience.nom_entreprise;
              const titreProjet = experience.titre_projet;
              const descriptionExperience = experience.description;
              if (experience.date_fin != null && experience.encour == 0) {
                moisFinExper = experience.date_fin.substring(5, 7);
                anneeFinexper = experience.date_fin.substring(0, 4);
              } else {
                encoureEper = experience.encour;
                moisFinExper = "";
                anneeFinexper = "";
              }

              return {
                ...experience,
                moisDebutExper,
                anneeDebutexper,
                moisFinExper,
                anneeFinexper,
                encoureEper,
                nomEntreprise,
                titreProjet,
                descriptionExperience,
              };
            }
          );

          setExperiences(updatedExperiences);

          const updatedLangue = response.data.langues.map((langue) => {
            const nomLangue = langue.nom;
            const niveauLangue = langue.niveau;

            return {
              ...langue,
              nomLangue,
              niveauLangue,
            };
          });

          setLangues(updatedLangue);

          const updatedCompetences = response.data.skills.map((sk) => {
            const skillNom = sk.nom;
            const niveauSkill = sk.niveau;

            return {
              ...sk,
              skillNom,
              niveauSkill,
            };
          });

          setCompetences(updatedCompetences);
        }

        setChargement(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleModifiereCv = () => {
    const competencesValides = competences.every((competence) => {
      if (
        (competence.skillNom !== "" && competence.niveauSkill === "") ||
        (competence.skillNom === "" && competence.niveauSkill !== "")
      ) {
        setMsgErreurTabCompetance("Ce champ est Obligatoire");
        return false;
      }
      return true;
    });

    // Si les compétences ne sont pas valides, arrêter ici
    if (!competencesValides) {
      return;
    }

    Swal.fire({
      title: "Traitement en cours, veuillez patienter ...",
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const form = new FormData();
    form.append("id", id);
    form.append("idOffre", idOffre);
    form.append("imageCV", image);
    form.append("nom", nom);
    form.append("tel", telephone);
    form.append("date_naissance", dateNaissance);
    form.append("domain_d_etude", domaineEtude);
    form.append("niveau", niveau);
    form.append("email", email);
    form.append("civilite", civilite);
    form.append("Apropos_Moi", descriptionCv);
    form.append("displayphoto", displayphoto);
    form.append("formations", JSON.stringify(formations));
    form.append("experiences", JSON.stringify(experiences));
    form.append("langues", JSON.stringify(langues));
    form.append("competences", JSON.stringify(competences));
    form.append("piecejointes", piecejointes);
    piecejointes.forEach((element) => {
      form.append("piecejointe[]", element);
    });

    axios
      .post("/modifierCv", form, {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        Swal.fire({
          icon: "success",
          text: "Votre CV a été modifié avec succès!",
          confirmButtonText: "Ok",
        }).then(function () {
          if (idOffre == null) {
            if (response.data.user.role == 1) {
              navigate(
                `${process.env.PUBLIC_URL}/consulter-cv/${response.data.cv.id}`
              );
            } else {
              navigate(`${process.env.PUBLIC_URL}/consulter-voter-cv`);
            }
          } else {
            navigate(
              `${process.env.PUBLIC_URL}/consulter-voter-cv-pour-postuler`
            );
          }
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onloadend = () => {
      setImageVisualise(reader.result);
    };

    reader.readAsDataURL(file);
    setImage(e.target.files[0]);
  };

  return chargement == true ? (
    <div className="container card text-center mt-5">
      <h4>Chargement .... </h4>
    </div>
  ) : (
    <ProtectedRoute>
      <FormCv
        image={image}
        imageVisualise={imageVisualise}
        onChangeImage={handleImageChange}
        // onChangeImage={(e) => setImage(e.target.files[0])}
        displayphoto={displayphoto}
        handleRadioChange={handleRadioChange}
        nom={nom}
        onChangeNom={(e) => setNom(e.target.value)}
        civilite={civilite}
        onChangeCivilite={(e) => setCivilite(e.target.value)}
        telephone={telephone}
        onChangeTelephone={(e) => setTelephone(e.target.value)}
        dateNaissance={dateNaissance}
        onChangeDateNaissance={(e) => setDateNaissance(e.target.value)}
        email={email}
        onChangeEmail={(e) => setEmail(e.target.value)}
        domaineEtude={domaineEtude}
        onChangeDomaineEtude={(e) => setDomaineEtude(e.target.value)}
        niveau={niveau}
        onChangeNiveau={(e) => setNiveau(e.target.value)}
        descriptionCv={descriptionCv}
        onChangeDescription={(e) => setDescriptionCv(e.target.value)}
        formations={formations}
        handleAjouterFormation={handleAjouterFormation}
        handleSupprimerFormation={handleSupprimerFormation}
        handleChangeFormation={handleChangeFormation}
        onChangeEtablissement={onChangeEtablissement}
        searchInputEtablissement={searchInputEtablissement}
        filteredResultsEtablissement={filteredResultsEtablissement}
        selectItemsEtablissement={selectItemsEtablissement}
        handleCheckboxChangeFormation={handleCheckboxChangeFormation}
        experiences={experiences}
        handleSupprimerExperience={handleSupprimerExperience}
        handleChangeExperience={handleChangeExperience}
        handleAjouterExperience={handleAjouterExperience}
        onChangeEntreprise={onChangeEntreprise}
        searchInputEntreprise={searchInputEntreprise}
        filteredResultsEntreprise={filteredResultsEntreprise}
        selectItemsEntreprise={selectItemsEntreprise}
        handleCheckboxChangeExperience={handleCheckboxChangeExperience}
        langues={langues}
        handleSupprimerLangue={handleSupprimerLangue}
        handleChangeLangue={handleChangeLangue}
        handleAjouterLangue={handleAjouterLangue}
        competences={competences}
        handleSupprimerCompetence={handleSupprimerCompetence}
        handleChangeCompetence={handleChangeCompetence}
        handleAjouterCompetence={handleAjouterCompetence}
        ajouterAuterFichier={ajouterAuterFichier}
        list={listPJ}
        removeFichier={removeFichier}
        ChangePJ={(e) => setPiecejointes((arr) => [...arr, e.target.files[0]])}
        msgErreurTap1={msgErreurTap1}
        msgErreurTabFormation={msgErreurTabFormation}
        msgErreurEncourForma={msgErreurEncourForma}
        msgDateForm={msgDateForm}
        msgErreurEncourExper={msgErreurEncourExper}
        msgErreurTabExperience={msgErreurTabExperience}
        msgErrDateExper={msgErrDateExper}
        msgErreurTabLangue={msgErreurTabLangue}
        msgErreurTabCompetance={msgErreurTabCompetance}
        checkValidateTabProfile={checkValidateTabProfile}
        errorMessagesTabProfile={errorMessagesTabProfile}
        checkValidateTabFormation={checkValidateTabFormation}
        errorMessagesTabFormation={errorMessagesTabFormation}
        checkValidateTabExperience={checkValidateTabExperience}
        errorMessagesTabExperience={errorMessagesTabExperience}
        checkValidateTabLangue={checkValidateTabLangue}
        errorMessagesTapLangue={errorMessagesTapLangue}
        checkValidateTabCompetance={checkValidateTabCompetance}
        errorMessagesTabLangueCompetance={errorMessagesTabLangueCompetance}
        handleSave={handleModifiereCv}
        currentIndex={currentIndex}
      />
    </ProtectedRoute>
  );
}
